/**
 * Copied from Rendering service's SquareMatrixSolver
 */
export class SquareMatrixSolver {
    constructor(matrix) {
        Object.defineProperty(this, "Singular", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0xbadf00d
        });
        // Uses LU decomposition to solve Ax=b for square A.
        // http://www.johnloomis.org/ece538/notes/Matrix/ludcmp.html
        Object.defineProperty(this, "_decmp", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_order", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (matrix.length != matrix[0].length) {
            throw new Error("Matrix must be square.");
        }
        let regVal = 0;
        const regMax = 1;
        do {
            this._decmp = matrix.map((arr) => arr.slice());
            this._order = [matrix.length];
            for (let i = 0; i < this._decmp.length; i++) {
                this._decmp[i][i] += regVal;
            }
            if (this.decompose(this._decmp, this._order) != this.Singular) {
                return;
            }
            regVal = (regVal + 1e-8) * 2;
        } while (regVal < regMax);
        throw new Error("Singular matrix could not be regularized");
    }
    solve(b) {
        let i, j;
        let sum;
        const n = this._decmp.length;
        const x = new Array(b.length).fill(0);
        for (i = 0; i < n; i++) {
            j = this._order[i];
            x[i] = b[j];
        }
        x[0] /= this._decmp[0][0];
        for (i = 1; i < n; i++) {
            sum = 0;
            for (j = 0; j < i; j++) {
                sum += this._decmp[i][j] * x[j];
            }
            x[i] = (x[i] - sum) / this._decmp[i][i];
        }
        for (i = n - 2; i >= 0; i--) {
            sum = 0;
            for (j = i + 1; j < n; j++) {
                sum += this._decmp[i][j] * x[j];
            }
            x[i] -= sum;
        }
        return x;
    }
    decompose(a, order) {
        let i, j, k;
        let flag = 1;
        let sum, diag;
        const n = a.length;
        for (let i = 0; i < n; i++) {
            order[i] = i;
        }
        if (this.pivot(a, order, 0) != 0) {
            flag = -flag;
        }
        diag = 1 / a[0][0];
        for (i = 1; i < n; i++) {
            a[0][i] *= diag;
        }
        const nm1 = n - 1;
        for (j = 1; j < nm1; j++) {
            for (i = j; i < n; i++) {
                sum = 0;
                for (k = 0; k < j; k++) {
                    sum += a[i][k] * a[k][j];
                }
                a[i][j] -= sum;
            }
            const pval = this.pivot(a, order, j);
            switch (pval) {
                case 0:
                    break;
                case 1:
                    flag = -flag;
                    break;
                default:
                    return this.Singular;
            }
            diag = 1 / a[j][j];
            for (k = j + 1; k < n; k++) {
                sum = 0;
                for (i = 0; i < j; i++) {
                    sum += a[j][i] * a[i][k];
                }
                a[j][k] = (a[j][k] - sum) * diag;
            }
        }
        sum = 0;
        for (k = 0; k < nm1; k++) {
            sum += a[nm1][k] * a[k][nm1];
        }
        a[nm1][nm1] -= sum;
        return flag;
    }
    pivot(a, order, jcol) {
        let i, ipvt;
        let big, anext;
        const n = a.length;
        ipvt = jcol;
        big = Math.abs(a[ipvt][ipvt]);
        for (i = ipvt + 1; i < n; i++) {
            anext = Math.abs(a[i][jcol]);
            if (anext > big) {
                big = anext;
                ipvt = i;
            }
        }
        if (Math.abs(big) < 1e-10) {
            return this.Singular;
        }
        if (ipvt == jcol) {
            return 0;
        }
        for (i = 0; i < a[0].length; i++) {
            const tmp = a[jcol][i];
            a[jcol][i] = a[ipvt][i];
            a[ipvt][i] = tmp;
        }
        i = order[jcol];
        order[jcol] = order[ipvt];
        order[ipvt] = i;
        return 1;
    }
}
//# sourceMappingURL=SquareMatrixSolver.js.map